import 'ol/ol.css';
import GeoJSON from 'ol/format/GeoJSON';
import Map from 'ol/Map';
//Vectors - to present vector layers
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import MVT from 'ol/format/MVT';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import OSM from 'ol/source/OSM.js';
//---- before the View
import View from 'ol/View';
import {defaults as defaultControls} from 'ol/control.js';
import MousePosition from 'ol/control/MousePosition.js';
import {createStringXY} from 'ol/coordinate.js';
import {toStringXY} from 'ol/coordinate.js';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS.js';
import XYZSource from 'ol/source/XYZ';
import {fromLonLat} from 'ol/proj';
import {transformExtent} from 'ol/proj.js';
import sync from 'ol-hashed';
// draganddrop - for importing new features
import DragAndDrop from 'ol/interaction/DragAndDrop';
//Modify features imported
import {defaults as defaultInteractions, Modify, Select} from 'ol/interaction.js';
//import Modify from 'ol/interaction/Modify';
// Drawing import
import Draw from 'ol/interaction/Draw';
//Snaping
import Snap from 'ol/interaction/Snap';
//style - for shaping the vectors
import {Circle as CircleStyle,Fill, Stroke, Style, Text} from 'ol/style.js';
// Overlay import
import Overlay from 'ol/Overlay';
//import Feature from 'ol/Feature';
//import WMSGetFeatureInfo from 'ol/format/WMSGetFeatureInfo';
//https://geotiffjs.github.io/geotiff.js/
import {getArea, getLength} from 'ol/sphere.js';
import {unByKey} from 'ol/Observable.js';
import {LineString, Polygon} from 'ol/geom.js';

//var helpTooltipElement;
// Variables
//Messages
var BrowseMessage = "Double click fo view info";
var EditMessage="Select and change";
var DeleteMessage ="Click to delete";
var Textmessage = 'Click to get info';
var DrawMessage = "Click to start";
var DrawMessageEnd = "Finished, Click to start drawing";
var OptionsMode = "Browsemode";
var drawing_started=0;
var SelectedID = 0
var output=0;
var length=0;
var modifystart=1;
var originalfeature=null;
var hole;
var modifying=0;
var saved=0;
var deleted=0;
var today = new Date();
var dd = String(today.getDate()).padStart(2, '0');
var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
var yyyy = today.getFullYear();
today = mm + '/' + dd + '/' + yyyy;

//console.log(document.getElementById('projection').value);

var mousePositionControl = new MousePosition({
        coordinateFormat: createStringXY(4),
        projection: document.getElementById('projection').value,
        // comment the following two lines to have the mouse position
        // be placed within the map.
        className: 'custom-mouse-position',
        target: document.getElementById('mouse-position'),
        undefinedHTML: '&nbsp;'
      });

//style for shaping the vectors
 var style = new Style({
        fill: new Fill({
//          color: 'rgba(255, 255, 255, 0.6)'
          color: 'rgba(255, 255, 255, 0.1)'
        }),
        stroke: new Stroke({
          color: '#319FD3',
          width: 2
        }),
        text: new Text(
{
          font: '12px Calibri,sans-serif',
          overflow: true,
          fill: new Fill({
            color: '#000'
             })
         }
),
image: new CircleStyle({
            radius: 7,
            fill: new Fill({
              color: '#ffcc33'
            })
          })
        

      });

//Transformations



function transform(extent) {
        return transformExtent(extent, 'EPSG:4326', 'EPSG:3857');
      };

var extents = {
        Albania: transform([19.3,39.7,21.09,42.7])
      };
        

const wmsextent = [19.3,39.7,21.09,42.7];

//Sources WMS


//OrtoCIR_LOT2:LOT2
//basemap:dem_hillshade
//qttb:perdorim2016end

var wmsSource = new TileWMS({
        url: 'https://geoportal.asig.gov.al/service/ows',
       projection:'EPSG:4326',
//url: 'https://geoportal.dgu.hr/services/inspire/orthophoto_2014-2016/wms',//Croatia
// cro      projection:'CRS:84',
        minZoom: 11,
//        params: {'LAYERS':"OI.OrthoImagery",'TILED': false, //Croatia
        params: {'LAYERS':"orthophoto_2015:OrthoImagery_20cm",'TILED': false, 
//        params: {'LAYERS':"OrtoCIR_LOT2:LOT2",'TILED': false, 
//params: {'LAYERS':"basemap:dem_hillshade",'TILED': false, 
//params: {'LAYERS':"qttb:perdorim2016end",'TILED': false, 
//params: {'LAYERS':"basemap:relief",'TILED': false, 
//params: {'LAYERS':"basemap:basemap-villages",'TILED': false, 
'FORMAT':'image/png'},
        serverType: 'geoserver'
});
const ALBlayer = new TileLayer({
//   extent: extents.Albania,
   source: wmsSource
});

var wmsALBCIRSource = new TileWMS({
        url: 'https://geoportal.asig.gov.al/service/ows',
        projection:'EPSG:4326',
        minZoom: 11,
//        params: {'LAYERS':"orthophoto_2015:OrthoImagery_20cm",'TILED': false, 
       params: {'LAYERS':"OrtoCIR_LOT2:LOT2",'TILED': false, 
//params: {'LAYERS':"basemap:dem_hillshade",'TILED': false, 
//params: {'LAYERS':"qttb:perdorim2016end",'TILED': false, 
//params: {'LAYERS':"basemap:relief",'TILED': false, 
//params: {'LAYERS':"basemap:basemap-villages",'TILED': false, 
'FORMAT':'image/png'},
        serverType: 'geoserver'
});

var wmsALBDEMSource = new TileWMS({
        url: 'https://geoportal.asig.gov.al/service/ows',
        projection:'EPSG:4326',
        minZoom: 11,
//        params: {'LAYERS':"orthophoto_2015:OrthoImagery_20cm",'TILED': false, 
//       params: {'LAYERS':"OrtoCIR_LOT2:LOT2",'TILED': false, 

// uselessparams: {'LAYERS':"Dtm_2015:Hillshade_2015_group",'TILED': false, 
//params: {'LAYERS':"basemap:relief",'TILED': false, 
params: {'LAYERS':"Dtm_2015:Dem_2015",'TILED': false, 
'FORMAT':'image/png', 'transparent':true},
        serverType: 'geoserver'
});


const ALBCIRlayer = new TileLayer({
   extent: extents.Albania,
   source: wmsALBCIRSource
});

const ALBDEMlayer = new TileLayer({
   extent: extents.Albania,
   source: wmsALBDEMSource
});


var wmsALBcad = new TileWMS({
   url: 'https://geoportal.asig.gov.al/service/ows',
// cro url: //'https://oss.uredjenazemlja.hr/OssWebServices/inspireService/wms?//token=bcd28508fda6c11a4f3c1af2eff047//8501a200b8a798afdf520f46a0d760e5cc',       
projection:'EPSG:4326',
        minZoom: 11,
//        params: {'LAYERS':"zrpp:parcelat",'TILED': false, 'FORMAT':'image/png', 'transperent':true},
//               params: {'LAYERS':"CP.CadastralParcel",'TILED': false, 'FORMAT':'image/png', //'transperent':true},//workable croatia
               params: {'LAYERS':"zrpp:alb_p_asig",'TILED': false, 'FORMAT':'image/png', 'transperent':true}, //woorkable albania
        serverType: 'geoserver'    
                 });
const ALBcadlayer = new TileLayer({
//   extent: extents.Albania,
   source: wmsALBcad
});

var GoogleSource =new XYZSource({
        url: 'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}'
      });



const googlemaps=new TileLayer({
//   extent: extents.Albania,
   source: GoogleSource
//new XYZSource({
//        url: 'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}'
//      })
});
const view=new View({
     projection: "EPSG:3857",
     center: [0, 0],
     zoom: 15
  })


const map=new Map({
  target: 'map-container',
  controls: defaultControls().extend([mousePositionControl]), 
  layers: [googlemaps
//     new TileLayer({
//      source: new XYZSource({
//        url: 'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}'
//      })
//        })
//,
//ALBlayer,
//ALBcadlayer
  ],
  view: view
});

map.addLayer(ALBlayer);
map.addLayer(ALBDEMlayer);
map.addLayer(ALBCIRlayer);
map.addLayer(ALBcadlayer);




sync(map);
// constant vector source - empty for import - adding new layer


//Open Layers
const googlestreet = new TileLayer({
  source: new XYZSource({
      url: 'https://mt1.google.com/vt/lyrs=h&x={x}&y={y}&z={z}'    
        })
});
map.addLayer(googlestreet);

const osmlayer = new TileLayer({
  source: new OSM()
});
map.addLayer(osmlayer);
osmlayer.setVisible(document.getElementById("1").checked);

//GeoJSON Layers
//const countries = new VectorLayer({
//  source: new VectorSource({
//        format: new GeoJSON(),
//        url: './data/countries.json'
//        
//      }),
//});
//map.addLayer(countries);


//user layers
const source = new VectorSource();
const layer = new VectorLayer({
  source: source,
  style: function(feature) {
      console.log('Check you get the property', feature.getId());
      style.getText().setText(feature.getId());
      return style;
    }
});
map.addLayer(layer);


// - end adding new layer with drop down

navigator.geolocation.getCurrentPosition(function(pos) {
  const coords = fromLonLat([pos.coords.longitude, pos.coords.latitude]);
  map.getView().animate({center: coords, zoom: 12});
console.log (coords);
console.log (pos	);
});

//Map overlay: feature overlay
var featureOverlay = new VectorLayer({
        source: new VectorSource(),
        map: map,
        style: new Style({
          stroke: new Stroke({
            color: '#f00',
            width: 1
          }),
          fill: new Fill({
            color: 'rgba(255,0,0,0.1)'
          }),
        })
       });

//Highlight selected feature function
      var highlight;
      var displayFeatureInfo = function(pixel) {
        var feature = map.forEachFeatureAtPixel(pixel, function(feature) {     
          return feature;
        });   
        var info1 = document.getElementById('info1');
        var IDunderpixel=feature.getId();
        if (feature) {
          console.log(feature.getId());
          info1.innerHTML = feature.getId() + ': ' + feature.get('name');
         
             var targetpolygon=feature.getGeometry();
              output=getArea(targetpolygon);
              length=getLength(targetpolygon);
              console.log ("output:"+output+"length:"+length); 
                console.log ("Properties: "+feature.getProperties());      
        } else {
          info1.innerHTML = '&nbsp;';
        }
        if (feature !== highlight) {
          if (highlight) {
            featureOverlay.getSource().removeFeature(highlight);
          }
          if (feature) {
            featureOverlay.getSource().addFeature(feature);
                      }
          highlight = feature;
        }
      };

// Countries are shown only if zoom level < 7
//const initial_country_value=document.getElementById("2").checked;
//view.on('change:resolution', function(evt) {
//	var current_zoom=map.getView().getZoom();
//	console.log ('zoom:'+current_zoom);
//	if (current_zoom > 6) {
//	   document.getElementById("2").checked = false;
//	   document.getElementById("2").disabled=true;
//	   countries.setVisible(false);}
//	else{
//	   document.getElementById("2").checked = initial_country_value;
//	   document.getElementById("2").disabled=false;
//	   countries.setVisible(true);
//	};
        
//});


//overlay in pop-up container 
//
const overlay = new Overlay({
  element: document.getElementById('popup-container'),
  positioning: 'bottom-center',
  offset: [0, -40],
//  autoPan: true
});
//map.addOverlay(overlay);

//overlay in pop-up container 
//



// Tooltip overlay - diplaying help texts on cursor
// function createHelpTooltip() {
//        if (helpTooltipElement) {
//          helpTooltipElement.parentNode.removeChild(helpTooltipElement);
//        }
        const helpTooltipElement = document.createElement('div');
//        helpTooltipElement.className = 'tooltip hidden';
        const helpTooltip = new Overlay({
          element: helpTooltipElement,
          offset: [20, 0],
          positioning: 'center-left'
        });
        map.addOverlay(helpTooltip);
//      }



//Events
//If pointer moved-over feature,  highlite te feature geometry, get the highlight

     map.on('pointermove', function(evt) {
//    map.on('dblclick', function(evt) {
            
      if (evt.dragging) {
          return;
        };


        var pixel = map.getEventPixel(evt.originalEvent);
//        displayFeatureInfo(pixel, layer);

     if (drawing_started >0) {Textmessage = 'Click for next verticle or to finish'} //else {
//Textmessage = 'Click to Draw'};
   helpTooltipElement.innerHTML = Textmessage;
   helpTooltip.setPosition(evt.coordinate);
           
      });

// If double cliked - display features of highlited feature
	map.on('dblclick', function(e) {
//map.on('pointermove', function(e) {
  let markup = '';
  map.forEachFeatureAtPixel(e.pixel, function(feature) {
    markup += `${markup && '<hr>'}<table>`;
    const properties = feature.getProperties();
    const PolyID = feature.getId();
document.getElementById('PolyID').value = PolyID;
document.getElementById('PolyName').value=properties.name;
document.getElementById('PolyUse').value=properties.name;
document.getElementById('PolyArea').value=properties.Area;
document.getElementById('IDClient').value=properties.name;
document.getElementById('IDCreated').value=properties.name;
document.getElementById('PolyDate').value=properties.Length;
console.log ('properties:'+properties.name);
    for (const property in properties) {
      markup += `<tr><th>${property}</th><td>${properties[property]}</td></tr>`;
    }
    markup += '</table>';
  }, {hitTolerance: 1});
  if (markup) {
    document.getElementById('popup-content').innerHTML = markup;

    overlay.setPosition(e.coordinate);
  } else {
    overlay.setPosition();
  }
});




//End overlay features - select Tool-texts for diplaying



map.on('dblclick', function (evt) {
//map.on('click', function (evt) {
//Display mouse coords
var mouseCoords = [evt.originalEvent.offsetX, evt.originalEvent.offsetY];
var mousecoord=map.getCoordinateFromPixel(mouseCoords);
document.getElementById('selected_locationX').value=mousecoord[0];
document.getElementById('selected_locationY').value=mousecoord[1];
document.getElementById('selected_projection').value="EPSG:3857";
console.log (mouseCoords);
var nogeom = source.getFeatures();
//.length;  
console.log ("ftrs"+nogeom.length);
var target1= map.getTarget();
//var IDs = target1.getId();
console.log ("target"+target1);

// display info on info on parcels WMS (info field)
document.getElementById('info').innerHTML = '';
        var viewResolution = /** @type {number} */ (view.getResolution());
       var url = wmsALBcad.getGetFeatureInfoUrl(
//var url = wmsSource.getGetFeatureInfoUrl(
          evt.coordinate, viewResolution, 'EPSG:3857',
//{'INFO_FORMAT': 'text/javascript'}); not supported
//{'INFO_FORMAT': 'text/plain'});
//        {'INFO_FORMAT': 'text/html'});
         {'INFO_FORMAT': 'application/json'});
         console.log (url);

//var url1 = wmsSource.getGetFeatureInfoUrl(
//var url1 = wmsALBCIRSource.getGetFeatureInfoUrl(
     var url1 = wmsALBDEMSource.getGetFeatureInfoUrl(
          evt.coordinate, viewResolution, 'EPSG:3857',
//{'INFO_FORMAT': 'text/javascript'}); not supported
//{'INFO_FORMAT': 'text/plain'});
//        {'INFO_FORMAT': 'text/html'});
         {'INFO_FORMAT': 'application/json'});
         console.log (url1);

        if (url) {
          document.getElementById('info').innerHTML = '<iframe  src="' + url + '"></iframe>';

document.getElementById("info1").innerHTML='<iframe id="iframe1" src="' + url1 + '"></iframe>';

var x = document.getElementById("info1").src;
var data;
$.getJSON(url, function(data) {
console.log (data);
console.log (data.features[0].properties);
document.getElementById("Cadzone").value=data.features[0].properties.nrzk
document.getElementById("Cadparcel").value=data.features[0].properties.nrpas
document.getElementById("CadArea").value=data.features[0].properties.shape_area

},function(success){
console.log (success);}
); 

//dem data

$.getJSON(url1, function(data) {
console.log (data);
console.log (data.features[0].properties);
document.getElementById("CadElev").value=data.features[0].properties.GRAY_INDEX
},function(success){
console.log (success);}
); 

//cir data
//$.getJSON(url1, function(data) {
//console.log (data);
//console.log (data.features[0].properties)
//},function(success){
//console.log (success);}
//);

var x = document.getElementById("info1");
var y = document.getElementById("info");

console.log (x);
console.log (y);




        }


//    alert(iFrameBody.innerHTML);
 
//document.getElementById('id_iframe').contentWindow.document.write('content');
//https://stackoverflow.com/questions/926916/how-to-get-the-bodys-content-of-an-iframe-in-javascript


//selection of feature
var pixel = evt.pixel;
        var feature = map.forEachFeatureAtPixel(pixel, function(feature) {     
          return feature;
        }); 

console.log ("pixel:"+pixel);
if (feature){
console.log ("featureID"+feature.getId());
SelectedID = feature.getId();
console.log ("SelectedID"+SelectedID);
var geom=feature.getGeometry();
//var FeaturesArray = select.getFeatures().getArray();
console.log (FeaturesArray);
console.log (getArea(geom))};
//case browse mode - display information
//Show_data(evt);
//case create mode - start/end drawing
//case change mode - select and start/end editing - display info on 


});


//
var projectionSelect = document.getElementById('projection');
      projectionSelect.addEventListener('change', function(event) {
        mousePositionControl.setProjection(event.target.value);
      });

      var precisionInput = document.getElementById('precision');
      precisionInput.addEventListener('change', function(event) {
        var format = createStringXY(event.target.valueAsNumber);
        mousePositionControl.setCoordinateFormat(format);
      });

//Drag and drop option - import own 

const DragAndDropPoly = new DragAndDrop({
  source: source,
  formatConstructors: [GeoJSON]
});

map.addInteraction(DragAndDropPoly);




// - adding new modifiable vector







//var pixel = evt.pixel;
//console.log ("pixel:"+pixel);



//cleaning
const clear = document.getElementById('clear');

clear.addEventListener('click', function() {
  if (confirm("Delete feature No "+ ExampleModify.select.getFeatures().getArray()[0].getId()+" ?")) {
      deleted=1;
      console.log ('Deleting-on-click:'+deleted);
      source.removeFeature(ExampleModify.select.getFeatures().getArray()[0]);
    
      ExampleModify.select.setActive(false);
      ExampleModify.select.setActive(true);
     source.refresh();
   }
});


const buttonsave= document.getElementById('buttonsave');
buttonsave.addEventListener('click', function(evt){
var selected_feature=ExampleModify.select.getFeatures().getArray()[0];
var Targetgeometry=selected_feature.getGeometry();
var FeatProperties=selected_feature.getProperties();
var FeatID=selected_feature.getId();
var attribes = { 
"name" : document.getElementById('FeatName').value, 
"Description": document.getElementById('FeatDesc').value, 
"Area": FeatProperties.Area, 
"FeatureType":FeatProperties.FeatureType,
"Length":FeatProperties.Length, 
"IDClient": document.getElementById('FeatIDClient').value, 
"Use": document.getElementById('FeatUse').value, 
"Elevation": document.getElementById('FeatSlope').value,
"Cadastre":document.getElementById('FeatCad').value, 
"Other_data": document.getElementById('Otherdata').value, 
"DateCreated": today,
"CreatorID": "TestUser"
};
selected_feature.setProperties(attribes);
       
console.log ("Save clicked"+ ExampleModify.select.getFeatures().getArray()[0].getId
            ());
});

//Downloading all of the features of user layer in GEoJSON format
const format = new GeoJSON({featureProjection: 'EPSG:3857'});
const download = document.getElementById('download');
source.on('change', function() {
  const features = source.getFeatures();
  const json = format.writeFeatures(features);
  download.href = 'data:text/json;charset=utf-8,' + json;
});

//Address search
document.getElementById("buttonsearch").onclick = function addr_search()
{

var inp = document.getElementById("addr");
console.log (inp);

//alert(inp.value);
var url3 ='https://nominatim.openstreetmap.org/search?format=json&limit=5&q=' + inp.value;
console.log (url3);
$.getJSON(url3, function(data) {
 console.log (data);
//alert(inp.value);
var items = [];
var bb = []; 
        $.each(data, function(key, val) {
//items.push("<li><a name=\"reference\" id=\"reference\" href='#' onclick='chooseAddr(" + val.lat + ", " + val.lon + ", \"" + val.type +"\""+ ",\"" + val.osm_type +"\");return false;'>" + val.display_name + '</a></li>');
            bb = val.boundingbox;
//            items.push("<li><a name=\"reference\" id=\"reference\" href='#' //onclick='chooseAddr(" + bb[0] + ", " + bb[2] + ", " + bb[1] + ", " + bb[3]  + ", \"" //+ val.type +"\""+ ",\""+ val.osm_type + "\");return false;'>" + val.display_name + //'</a></li>');
 
var loc1="["+val.lon+","+val.lat+"]";
var loc2=[val.lon,val.lat];
const loc = fromLonLat([val.lon, val.lat]);
    
items.push("<li><a name=\"reference\" id=\"reference\" href='#' > <input id='ss' type='text' value ="+loc2+" hidden=true>"+ val.display_name + '</a></li>');               



 });
console.log (bb);
console.log (items);



//Displaying results of search
$('#results').empty();
    if (items.length != 0) {
      $('<p>', { html: "Search results:" }).appendTo('#results');
      $('<ul/>', {
        'class': 'my-new-list',
        html: items.join('')
      }).appendTo('#results');
    } else {
      $('<p>', { html: "No results found" }).appendTo('#results');
    }
  });
};


document.getElementById("results").onclick=function Loc_zoom(){
//document.getElementById("ss").onclick=function Loc_zoom(){
var location =[]; 
location = JSON.parse("["+document.getElementById("ss").value+"]");
//location = $("#results").val();
console.log ("location: "+ location);
//document.getElementById("results").value = location;
var coords1=location;
var coords3 =document.getElementById("results").value;
console.log ("coords1: "+ coords1[0]);
var coords2 =fromLonLat([coords1[0],coords1[1]]);
console.log ("coords:"+ coords1);
console.log ("coords2:"+ coords2);
//alert (coords1);
map.getView().animate({center: coords2, zoom: 15});
};






var ExampleModify = {
        init: function() {
        this.select= new Select({
        wrapX: false,
        layers: [layer]
        }),             
        map.addInteraction(this.select);
        this.modify= new Modify({
 //           source: source,
            features: this.select.getFeatures()
          });
          map.addInteraction(this.modify);
          this.setEvents();
        },    
        
        setEvents: function() {
          var selectedFeatures = this.select.getFeatures();
            this.select.on('change:active', function() {
            selectedFeatures.forEach(function(each) {
              selectedFeatures.remove(each);
            });
          });
        },
//        select: new Select({
//        wrapX: false,
//        layers: [layer]
//        }),
          setActive: function(active) {
          this.select.setActive(active);
          this.modify.setActive(active);
        }
      };

ExampleModify.init();



var optionsForm = document.getElementById('options-form');

 var ExampleDraw = {
        init: function() {
          map.addInteraction(this.Point);
          this.Point.setActive(false);
          map.addInteraction(this.LineString);
          this.LineString.setActive(false);
          map.addInteraction(this.Polygon);
          this.Polygon.setActive(false);
//          map.addInteraction(this.Circle);
//          this.Circle.setActive(false);
        },
        Point: new Draw({
          source: source,
          type: 'Point'
        }),
        LineString: new Draw({
          source: source,
          type: 'LineString'
        }),
        Polygon: new Draw({
          source: source,
          type: 'Polygon'
        }),
//        Circle: new Draw({
//          source: source,
//          type: 'Circle'
//        }),
        getActive: function() {
          return this.activeType ? this[this.activeType].getActive() : false;
        },
        setActive: function(active) {
          var type = optionsForm.elements['draw-type'].value;
          console.log ("Drawtype:"+type);
          if (active) {
            this.activeType && this[this.activeType].setActive(false);
            this[type].setActive(true);
            this.activeType = type;
          } else {
            this.activeType && this[this.activeType].setActive(false);
            this.activeType = null;
          }
        }
      };
      ExampleDraw.init();

     

      optionsForm.onchange = function(e) {
        var type = e.target.getAttribute('name');
       console.log ("type:"+type);
        var value = e.target.value;
       console.log ("value"+value);
       if (saved== 0){console.log('not saved')};
       saved = 1;
        if (type == 'draw-type') {
          ExampleDraw.getActive() && ExampleDraw.setActive(true);
        } else if (type == 'options') {
          if (value == 2) {
            Textmessage = 'Click to Modify';
            ExampleModify.select.setActive(false);
            ExampleDraw.setActive(false);
            ExampleModify.setActive(true);  
            document.getElementById("buttonsave").style.visibility="visible";    
            console.log ("Modifyig mode");
          } else if (value == 1){
            Textmessage = 'Click to Draw';
            ExampleDraw.setActive(true);
            ExampleModify.setActive(false);
            document.getElementById("buttonsave").style.visibility="hidden";
            console.log ("Drawing mode");
          } else if (value == 0){
            Textmessage = 'Click on to get info';
            ExampleDraw.setActive(false);
            ExampleModify.setActive(false);
            ExampleModify.select.setActive(true);
            console.log ("Browse mode");
          } else if (value == 3){
            Textmessage = 'Click to Select';
            ExampleDraw.setActive(false);
            ExampleModify.setActive(false);
            ExampleModify.select.setActive(true);                      
            console.log ("Delete mode");}
        }
      };

var backup_feature=[];
var modified_feature=[];

ExampleModify.select.on('select', function() { 
//ExampleModify.select.getFeatures().on('add', function(evt){
//ExampleModify.modify.on('modifystart', function(evt){
//console.log ('New feature selected');
saved = 1;//remove when database
//activate when database
if (saved==0){
console.log ('Selected, previous not saved');
if (document.getElementById('options2').checked){
console.log ('Modifying'+modifying);
if (modifying==1){ 
if (confirm("Save?")) {
    saved=1;
    modifying=0;
  } else {
    saved=1;
    modifying=0;
//var i = 0;
//console.log(backup_feature.length);
//for (i = 0; i < modified_feature.flatCoordinates.length; i++) {
//modified_feature.flatCoordinates[i]=null;
//};
//for (i = 0; i < backup_feature.length; i++) {
//modified_feature.flatCoordinates[i]=backup_feature[i];
//};

//    console.log(modified_feature);
//    source.refresh();
  }};
//activate when database
}};
var selected_feature=ExampleModify.select.getFeatures().getArray()[0];
var Targetgeometry=selected_feature.getGeometry();
var FeatProperties=selected_feature.getProperties();
var FeatID=selected_feature.getId();
var i=0;

//var Area1=getArea(geometry1);
//var Length1=getLength(geometry1);
document.getElementById('FeatID').value = FeatID;
document.getElementById('FeatIDClient').value=FeatProperties.IDClient;
document.getElementById('FeatName').value=FeatProperties.name;
document.getElementById('FeatUse').value=FeatProperties.Use;
document.getElementById('FeatDesc').value=FeatProperties.Description;
document.getElementById('FeatCad').value=FeatProperties.Cadastre;
document.getElementById('FeatSlope').value=FeatProperties.Elevation;
document.getElementById('FeatType').value=FeatProperties.FeatureType;
document.getElementById('FeatArea').value=FeatProperties.Area;
document.getElementById('FeatIDClient').value=FeatProperties.IDClient;
document.getElementById('FeatIDCreated').value=FeatProperties.CreatorID;
document.getElementById('FeatLength').value=FeatProperties.Length;
document.getElementById('FeatX').value=Targetgeometry.flatCoordinates[0];
document.getElementById('FeatY').value=Targetgeometry.flatCoordinates[1];
document.getElementById('FeatDate').value=FeatProperties.DateCreated;
document.getElementById('Otherdata').value=FeatProperties.Other_data;

//Textmessage = 'Modify or Save when finished';
if (document.getElementById('options0').checked){
Textmessage = 'Click to get Info';
source.refresh();
};

if (document.getElementById('options2').checked){
console.log ('Modifying'+modifying);

console.log ('Saved:'+saved);
Textmessage = 'Modify or Save when finished';
source.refresh();
};
source.refresh();
if (document.getElementById('options3').checked){
if (selected_feature){
var FeatID=selected_feature.getId();
      if (confirm("Delete? "+ FeatID)) {
      deleted=1;
      console.log ('Deleting-on-click:'+deleted);
      source.removeFeature(selected_feature);
      ExampleModify.select.setActive(false);
      ExampleModify.select.setActive(true);
     source.refresh();};
};

};


});


ExampleModify.select.on('remove', function() {
var selected_feature=ExampleModify.select.getFeatures().getArray()[0];
console.log ('Selected');
if (document.getElementById('options3').checked){
if (selected_feature){
var FeatID=selected_feature.getId();
      if (confirm("Delete? "+ FeatID)) {
      deleted=1;
      console.log ('Deleting-on-click:'+deleted);
      source.removeFeature(selected_feature);
      ExampleModify.select.setActive(false);
      ExampleModify.select.setActive(true);
      source.refresh();};
};};
});


ExampleModify.modify.on('modifyend', function(evt){
console.log ('Modifyend');
helpTooltip.setPosition(evt.coordinate);
var selected_feature=ExampleModify.select.getFeatures().getArray()[0];
var Targetgeometry=selected_feature.getGeometry();
var FeatProperties=selected_feature.getProperties();
var FeatID=selected_feature.getId();
//var Area1=getArea(geometry1);
//var Length=getLength(geometry1);
var Area=Math.trunc(getArea(Targetgeometry));
var length=Math.trunc(getLength(Targetgeometry));
document.getElementById('FeatID').value = FeatID;
document.getElementById('FeatName').value=FeatProperties.name;
document.getElementById('FeatIDClient').value=FeatProperties.IDClient;
document.getElementById('FeatUse').value=FeatProperties.Use;
document.getElementById('FeatDesc').value=FeatProperties.Description;
document.getElementById('FeatCad').value=FeatProperties.Cadastre;
document.getElementById('FeatSlope').value=FeatProperties.Elevation;
document.getElementById('FeatType').value=FeatProperties.FeatureType;
document.getElementById('FeatArea').value=Area;
document.getElementById('FeatIDClient').value=FeatProperties.IDClient;
document.getElementById('FeatIDCreated').value=FeatProperties.CreatorID;
document.getElementById('FeatLength').value=length;
document.getElementById('FeatX').value=Targetgeometry.flatCoordinates[0];
document.getElementById('FeatY').value=Targetgeometry.flatCoordinates[1];
document.getElementById('FeatDate').value=FeatProperties.DateCreated;
document.getElementById('Otherdata').value=FeatProperties.Other_data;
modified_feature=Targetgeometry;
console.log ('backup_feature while modifying');
console.log (backup_feature);
modifying=1;
saved=0;
});



ExampleDraw.Polygon.on('drawstart',
//ExampleDraw.on('drawstart',
          function(evt) {
            var geom = evt.feature;
            /** @type {module:ol/coordinate~Coordinate|undefined} */
            var tooltipCoord = evt.coordinate;
drawing_started =1;
console.log ("drawing_started");
         
          });

ExampleDraw.Point.on('drawstart',
//ExampleDraw.on('drawstart',
          function(evt) {
            var geom = evt.feature;
            /** @type {module:ol/coordinate~Coordinate|undefined} */
            var tooltipCoord = evt.coordinate;
drawing_started =1;
console.log ("drawing_started-point");
         
          });
ExampleDraw.LineString.on('drawstart',
//ExampleDraw.on('drawstart',
          function(evt) {
            var geom = evt.feature;
            /** @type {module:ol/coordinate~Coordinate|undefined} */
            var tooltipCoord = evt.coordinate;
drawing_started =1;
console.log ("drawing_started-point");
         
          });

ExampleDraw.Polygon.on('drawend', function (evt){
//ExampleDraw.on('drawend', function (evt){
Textmessage = 'Finished, Click to Draw or select other option';
helpTooltipElement.innerHTML = 'Finished, Click to Draw or select other option';drawing_started =0;
var geom = evt.feature;
console.log ("evtfeatureend:"+evt.feature);
console.log ("geometry:"+geom.getGeometry());
var nogeom = source.getFeatures();
var hexString = nogeom.length.toString(16);
geom.setId(hexString);
var Targetgeometry=geom.getGeometry();
output=Math.trunc(getArea(Targetgeometry));
length=Math.trunc(getLength(Targetgeometry));
console.log (output,length);
console.log (Targetgeometry);
var attribes = { "name" : "Myname"+nogeom.length, "Description": "", "Area": output, "FeatureType":"Polygon","Length":length, "IDClient": " ", "Use": " ", "Elevation": " ","Cadastre":" ", "Other_data": "Enter other data", "DateCreated": today,"CreatorID": "TestUser"};
geom.setProperties(attribes);
var FeatID=geom.getId(); 
//var FeatType=geom.getId();
var FeatProperties=geom.getProperties();
document.getElementById('FeatID').value = FeatID;
document.getElementById('FeatName').value=FeatProperties.name;
document.getElementById('FeatIDClient').value=FeatProperties.IDClient;
document.getElementById('FeatUse').value=FeatProperties.Use;
document.getElementById('FeatDesc').value=FeatProperties.Description;
document.getElementById('FeatCad').value=FeatProperties.Cadastre;
document.getElementById('FeatSlope').value=FeatProperties.Elevation;
document.getElementById('FeatType').value=FeatProperties.FeatureType;
document.getElementById('FeatArea').value=FeatProperties.Area;
document.getElementById('FeatIDClient').value=FeatProperties.IDClient;
document.getElementById('FeatIDCreated').value=FeatProperties.CreatorID;
document.getElementById('FeatLength').value=FeatProperties.Length;
document.getElementById('FeatX').value=Targetgeometry.flatCoordinates[0];
document.getElementById('FeatY').value=Targetgeometry.flatCoordinates[1];
document.getElementById('FeatDate').value=FeatProperties.DateCreated;
document.getElementById('Otherdata').value=FeatProperties.Other_data;
console.log ("Properties Draw: "+geom.getProperties());
console.log ('end draw');});

ExampleDraw.Point.on('drawend', function (evt){
Textmessage = 'Finished, Click to Draw or select other option';
helpTooltipElement.innerHTML = 'Finished, Click to Draw or select other option';drawing_started =0;
var geom = evt.feature;
console.log ("evtfeatureend:"+evt.feature);
console.log ("geometry:"+geom.getGeometry());
var nogeom = source.getFeatures();
var hexString = nogeom.length.toString(16);
geom.setId(hexString);
var Targetgeometry=geom.getGeometry();
output=Math.trunc(getArea(Targetgeometry));
length=Math.trunc(getLength(Targetgeometry));
console.log (output,length);
console.log (Targetgeometry);
var attribes = { "name" : "Myname"+nogeom.length, "Description": "", "Area": output, "FeatureType":"Point","Length":length, "IDClient": " ", "Use": " ", "Elevation": " ","Cadastre":" ", "Other_data": "Enter other data", "DateCreated": today,"CreatorID": "TestUser"};
geom.setProperties(attribes);
var FeatID=geom.getId(); 
var FeatType=geom.getId();
var FeatProperties=geom.getProperties();
document.getElementById('FeatID').value = FeatID;
document.getElementById('FeatName').value=FeatProperties.name;
document.getElementById('FeatIDClient').value=FeatProperties.IDClient;
document.getElementById('FeatType').value=FeatProperties.FeatureType;
document.getElementById('FeatArea').value="N/A";
document.getElementById('FeatIDClient').value=FeatProperties.IDClient;
document.getElementById('FeatIDCreated').value=FeatProperties.CreatorID;
document.getElementById('FeatLength').value="N/A";
document.getElementById('FeatX').value=Targetgeometry.flatCoordinates[0];
document.getElementById('FeatY').value=Targetgeometry.flatCoordinates[1];
document.getElementById('FeatDate').value=FeatProperties.DateCreated;
document.getElementById('Otherdata').value=FeatProperties.Other_data;
console.log ("Properties Draw: "+geom.getProperties());
console.log ('end draw');});


ExampleDraw.LineString.on('drawend', function (evt){
Textmessage = 'Finished, Click to Draw or select other option';
helpTooltipElement.innerHTML = 'Finished, Click to Draw or select other option';drawing_started =0;
var geom = evt.feature;
console.log ("evtfeatureend:"+evt.feature);
console.log ("geometry:"+geom.getGeometry());
var nogeom = source.getFeatures();
var hexString = nogeom.length.toString(16);
geom.setId(hexString);
var Targetgeometry=geom.getGeometry();
output=Math.trunc(getArea(Targetgeometry));
length=Math.trunc(getLength(Targetgeometry));
console.log (output,length);
console.log (Targetgeometry);
var attribes = { "name" : "Myname"+nogeom.length, "Description": "", "Area": output, "FeatureType":"LineString","Length":length, "IDClient": " ", "Use": " ", "Elevation": " ","Cadastre":" ", "Other_data": "Enter other data", "DateCreated": today,"CreatorID": "TestUser"};
geom.setProperties(attribes);
var FeatID=geom.getId(); 
var FeatType=geom.getId();
var FeatProperties=geom.getProperties();
document.getElementById('FeatID').value = FeatID;
document.getElementById('FeatName').value=FeatProperties.name;
document.getElementById('FeatIDClient').value=FeatProperties.IDClient;
document.getElementById('FeatType').value=FeatProperties.FeatureType;
document.getElementById('FeatArea').value="N/A";
document.getElementById('FeatIDClient').value=FeatProperties.IDClient;
document.getElementById('FeatIDCreated').value=FeatProperties.CreatorID;
document.getElementById('FeatLength').value=FeatProperties.Length;
document.getElementById('FeatX').value=Targetgeometry.flatCoordinates[0];
document.getElementById('FeatY').value=Targetgeometry.flatCoordinates[1];
document.getElementById('FeatDate').value=FeatProperties.DateCreated;
document.getElementById('Otherdata').value=FeatProperties.Other_data;
console.log ("Properties Draw: "+geom.getProperties());
console.log ('end draw-linestring');});


const PolySnap=new Snap({
   source: layer.getSource(),
pixelTolerance: 10
});

//Adding snapping
map.addInteraction(PolySnap);




// set layer visibility
document.getElementById("0").onclick=function(){googlestreet.setVisible(document.getElementById("0").checked)};
document.getElementById("1").onclick=function(){osmlayer.setVisible(document.getElementById("1").checked)};
document.getElementById("2").onclick=function(){countries.setVisible(document.getElementById("2").checked);
const initial_country_value=document.getElementById("2").checked};
document.getElementById("5").onclick=function(){ALBcadlayer.setVisible(document.getElementById("5").checked);if (document.getElementById("5").checked){
document.getElementById("editcad").style.visibility="visible";}else {document.getElementById("editcad").style.visibility="hidden";}};
document.getElementById("6").onclick=function(){ALBCIRlayer.setVisible(document.getElementById("6").checked)};
document.getElementById("4").onclick=function(){googlemaps.setVisible(document.getElementById("4").checked)};
document.getElementById("8").onclick=function(){ALBlayer.setVisible(document.getElementById("8").checked)};
document.getElementById("7").onclick=function(){ALBDEMlayer.setVisible(document.getElementById("7").checked)};
document.getElementById("3").onclick=function(){layer.setVisible(document.getElementById("3").checked);if (document.getElementById("3").checked){
document.getElementById("editw").style.visibility="visible";}else {document.getElementById("editw").style.visibility="hidden";}};